import { render, staticRenderFns } from "./UserEmptyContactsWindow.vue?vue&type=template&id=1c6d0eae&scoped=true"
import script from "./UserEmptyContactsWindow.vue?vue&type=script&lang=js"
export * from "./UserEmptyContactsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d0eae",
  null
  
)

export default component.exports